import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: {},
  error: null,
  loading: false,
};

const getUserSettingsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getUserSettingsRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};
const getUserSettingsRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: payload.data,
    error: null,
    loading: false,
  };
};

const showIntacctId = (state) => {
  return {
    ...state,
    showIntacctId: true,
  };
};
const hideIntacctId = (state) => {
  return {
    ...state,
    showIntacctId: false,
  };
};

const updateUserSettingsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const updateUserSettingsRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error.message,
    loading: false,
  };
};
const updateUserSettingsRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: { ...payload.data },
    error: null,
    loading: false,
  };
};

export default handleActions(
  {
    [types.GET_USER_SETTINGS_REQUEST]: getUserSettingsRequest,
    [types.GET_USER_SETTINGS_REQUEST_FAILURE]: getUserSettingsRequestFailure,
    [types.GET_USER_SETTINGS_REQUEST_SUCCESS]: getUserSettingsRequestSuccess,
    [types.HIDE_INTACCT_ID]: hideIntacctId,
    [types.SHOW_INTACCT_ID]: showIntacctId,
    [types.UPDATE_USER_SETTINGS_REQUEST]: updateUserSettingsRequest,
    [types.UPDATE_USER_SETTINGS_REQUEST_FAILURE]: updateUserSettingsRequestFailure,
    [types.UPDATE_USER_SETTINGS_REQUEST_SUCCESS]: updateUserSettingsRequestSuccess,
  },
  initialState
);
